module.exports = __webpack_public_path__ + "static/img/asideBanner.4b01e9ac.png";